import { API_ENDPOINT, useClientApiV1GuidesIdQuery } from '../../resources/@types/uccSchema';

type GuidesIdQueryOptions = Parameters<typeof useClientApiV1GuidesIdQuery>[0]['options'];

export default function useGuidesIdQuery(guideId: number, options?: GuidesIdQueryOptions) {
  return useClientApiV1GuidesIdQuery({
    queryKey: getGuidesIdQueryKey(guideId),
    url: API_ENDPOINT.CLIENT_V1_GUIDES_ID(String(guideId)),
    options,
  });
}

export const getGuidesIdQueryKey = (guideId: number) => [
  API_ENDPOINT.CLIENT_V1_GUIDES_ID(String(guideId)),
];
